import { Injectable } from '@angular/core';
import { DispatchDTO, OrderDTO } from '../../interfaces/models';

@Injectable()
export class ModalConfigurationStoreService {


  modals = {
    static: {
      walletToAdd: {
        width: '450px',
          data: {
            action: 'Confirm Block',
            description: 'In Order to Request a load to be Dispatched, you need to set up your Wallet. This is to facilitate payments' +
              'for all dispatched loads and to pay any outstanding Broker fees. Payments will be proceed within 24 hours.' +
              ' By setting up your Wallet, you allow us to make ACH' +
              'transfers to your account any outstanding Broker fees. When a load has a Broker Fee you will by notified accordingly',
            nameButton: 'Confirm',
        }
      },
      walletAdded: {
        width: '450px',
        data: {
          action: 'Confirm Block',
          description: 'Wallet set up successfully',
          nameButton: 'Confirm',
          hideCancel: true,
        },
      },
      cancelRequestedOrder: {
        width: '450px',
        data: {
          action: 'Confirm Cancel',
          description: 'Are you sure?',
          nameButton: 'Confirm',
          reason: false,
        },
      },
      cancelOrder: {
        width: '450px',
        data: {
          action: 'Confirm Cancel',
          description: 'Are you sure?',
          nameButton: 'Confirm',
          reason: false,
        },
      },
      deleteCompletelyOrder: {
        width: '450px',
        data: {
          action: 'Confirm delete',
          description: 'This Operation will permanently delete this order from your account. Would you like to continue?',
          nameButton: 'Delete',
          reason: false,
        }
      },
      deleteTrip: {
        width: "450px",
        data: {
          action: "Confirm Remove",
          description: "Are you sure?",
          nameButton: "Confirm",
          reason: false
        }
      },
      publish: {
        width: '450px',
        data: {
          action: 'Confirm',
          description: 'Are you sure?',
          nameButton: 'Publish',
          reason: false,
        },
      },
      unpublish: {
        width: '450px',
        data: {
          action: 'Confirm',
          description: 'Are you sure?',
          nameButton: 'Unpublish',
          reason: false,
        },
      },
      deleteOrderFromTrip: {
        width: '450px',
        data: {
          action: 'Confirm Delete',
          description: 'Are you sure?',
          nameButton: 'Confirm',
          reason: false,
        },
      },
      deleteOrderFromTripCompletely: {
        width: '450px',
        data: {
          action: 'Confirm Delete',
          description: 'Removing the only order in the trip will completely delete the whole Trip. Please confirm to continue',
          nameButton: 'Confirm',
          reason: false,
        },
      }
    },
    dynamic: {
      createWallet: (company) => ({
        width: '600px',
        height: '785px',
        data: { company },
      }),
      dispatchOrder: (order: OrderDTO) => ({
        data: {
          orderId: order.id,
          pickDate: order.pickDate,
          deliveryDate: order.deliveryDate,
          message: 'Create request dispatch',
        },
        width: '450px',
      }),
      requestDifferentTerms: (order: OrderDTO, dispatch: DispatchDTO) => ({
        data: {
          orderId: order.id,
          pickDate: dispatch.pickDate,
          deliveryDate: dispatch.deliveryDate,
          message: 'Request different terms',
          id: dispatch.id,
        },
        width: '450px',
      }),
      addTrip: (order: OrderDTO) => ({
        data: {
          orderId: order.id,
          tripId: order.tripId,
        },
        width: '700px',
        minHeight: '400px',
      }),
      addQuoteNote: (quoteId) => ({
        width: '450px',
        data: { quoteId }
      }),
    }
  }

  constructor() { }
}
